/*SYSTEM IMPORTS*/
import React from 'react'
import c from 'classnames'

import './style'
import './media'


const Cont = props => (
    <div id={props.id} className={c("cont", props.className)}>
        <div className="container">
            {props.children}
        </div>
    </div>
)

export default Cont
